import { GridLayout } from "src/app/classes/widget/dashboard-grid";
import { WidgetV2 } from "../api/chart";
import { User } from "./auth";

export interface DashboardContent {
  accessKey?: string,
  charts: WidgetV2[],
  id: string,
  index?: string,
  label?: string,
  mailingList?: string[],
  projects?: any[],
  projectSettings?: any[],
  autoRefresh: any,
  refresh?: any,
  export?: any,
  report?: any,
  reports?: any,
  title?: string,
  type?: string,
  version: number
}

export interface Dashboard {
  id: string;
  title?: string;
  description?: string;
  owner?: User | string;
  users?: string[];
  charts?: (WidgetV2 | string)[];
  // Widget placement; absent until first change.
  layout?: GridLayout;
  projects?: string[];
  projectSettings: {
    title?: string;
    project: string;
    mailingList: string[];
    startDate?: string | number;
    endDate?: string | number;
    units?: string[];
    reportFrequency: 'never' | 'daily' | 'weekly' | 'monthly';
    index?: number;
  }[];
  accessKey?: string;
  autoRefresh?: {
    unit: 'minute' | 'hour' | null;
    value?: number;
  };
  version?: number;
  export?: any,
  refresh?: any;
  report?: any;
}

const defaultDashboard: Dashboard = {
  id: "user",
  charts: [],
  autoRefresh: {
    unit: null
  },
  version: 0,
  projectSettings: []
};

export default defaultDashboard;